import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { accountingNumberFormatter } from "@common/helpers/number";
import { MoneyDirection } from "@common/constants";
import { useGlobalTransactionViewDrawer } from "@components/transactions/TransactionViewDrawer/useGlobalTransactionViewDrawer";
import classNames from "classnames";
import { ChartOfAccountsRow, SUBTYPE_TO_SWAP_DIRECTIONS } from "../utils";
import styles from "../styles.module.scss";

export const DebitCell = memo(
    ({ row }: CellContext<ViewTableFeatures, ChartOfAccountsRow, number>) => {
        const rowData = row.original;
        const openGlobalTransactionViewDrawer =
            useGlobalTransactionViewDrawer();

        // Classification row - no debit
        if (rowData.classification) {
            return <ViewTableCell />;
        }

        if (rowData.group) {
            return (
                <ViewTableCell>
                    <div className={styles.columnContent}>
                        {accountingNumberFormatter(rowData.groupDebit ?? 0)}
                    </div>
                </ViewTableCell>
            );
        }

        // Account row
        if (rowData.account && rowData.entityIds && rowData.accountIds) {
            const debitDirection = SUBTYPE_TO_SWAP_DIRECTIONS.includes(
                rowData.account.subtype,
            )
                ? MoneyDirection.MONEY_IN
                : MoneyDirection.MONEY_OUT;

            return (
                <ViewTableCell>
                    <div
                        className={classNames(styles.columnContent, {
                            [styles.debitColumn]: rowData.account.debit,
                        })}
                        onClick={() => {
                            if (!rowData.account?.debit) {
                                return;
                            }

                            openGlobalTransactionViewDrawer({
                                coaAccounts: rowData.accountIds,
                                entityIds: rowData.entityIds,
                                direction: debitDirection,
                            });
                        }}
                    >
                        {accountingNumberFormatter(rowData.account.debit)}
                    </div>
                </ViewTableCell>
            );
        }

        return <ViewTableCell />;
    },
);
